// Client Store

import { getField, updateField } from 'vuex-map-fields'
import { isEmpty, cloneDeep } from 'lodash'

const client = {
  admin_handle: {},
  billing_handle: {},
  contact_handle: {
    type: 'PERS',
    sex: null,
    firstname: null,
    lastname: null,
    organisation: null,
    street: null,
    number: null,
    city: null,
    zip: null,
    country: null,
    phone: null,
    fax: null,
    email: null,
    unique_name: null,
  },
  customer: null,
  id: null,
  paymenttypes: null,
  pricelist_id: null,
  reversecharge: false,
  vatid: null,
  vatoverride: null,
  tenant_id: null,
  contact_handle_id: null,
  admin_handle_id: null,
  billing_handle_id: null,
}

const state = {
  client: cloneDeep(client),
  invoices: [],
  errors: {},
  foundClients: [],
  options: {},
  pending: {},
}

const getters = {
  isUnique: ({ client }) => client && client.contact_handle && !isEmpty(client.contact_handle.unique_name),
  getField,
}

const actions = {
  getClient({ commit, rootState }) {
    return new Promise((resolve, reject) => {
      const { type } = rootState.route.meta
      const { id } = rootState.route.params

      commit('SET_PENDING', { pending: true, type: 'getClient' })

      this.api.item
        .getItem(type, id)
        .then(({ data }) => {
          commit('GET_CLIENT_SUCCESS', data)
          resolve()
        })
        .catch(error => {
          commit('GET_CLIENT_FAIL', error)
          reject(error)
        })
        .finally(_ => {
          commit('SET_PENDING', { pending: false, type: 'getClient' })
        })
    })
  },
  getEditClient({ commit, rootState }) {
    return new Promise((resolve, reject) => {
      const { type } = rootState.route.meta
      const { id } = rootState.route.params

      commit('SET_PENDING', { pending: true, type: 'getEditClient' })

      this.api.item
        .getEditItem(type, id)
        .then(({ data }) => {
          commit('GET_CLIENT_SUCCESS', data)
          resolve()
        })
        .catch(error => {
          commit('GET_CLIENT_FAIL', error)
          reject(error)
        })
        .finally(_ => {
          commit('SET_PENDING', { pending: false, type: 'getEditClient' })
        })
    })
  },
  getOptions({ commit, rootState }) {
    return new Promise((resolve, reject) => {
      const { type } = rootState.route.meta

      commit('SET_PENDING', { pending: true, type: 'clientOptions' })

      this.api.item
        .getOptions(type)
        .then(({ data }) => {
          commit('GET_CLIENT_OPTIONS_SUCCESS', data)
          resolve()
        })
        .catch(error => {
          commit('GET_CLIENT_OPTIONS_FAIL', error)
          reject(error)
        })
        .finally(_ => {
          commit('SET_PENDING', { pending: false, type: 'clientOptions' })
        })
    })
  },
  createClient({ commit, state, rootState }) {
    return new Promise((resolve, reject) => {
      const { type } = rootState.route.meta

      commit('SET_PENDING', { pending: true, type: 'createClient' })

      delete state.client.billing_handle
      delete state.client.admin_handle

      this.api.item
        .addItem(type, state.client)
        .then(({ data }) => {
          if (data && data.errors) {
            commit('ADD_CLIENT_FAIL', data.errors)
            return
          }
          commit('ADD_CLIENT_SUCCESS')
          resolve(data)
        })
        .catch(error => {
          commit('ADD_CLIENT_FAIL', error)
          reject(error)
        })
        .finally(_ => {
          commit('SET_PENDING', { pending: false, type: 'createClient' })
        })
    })
  },
  editClient({ commit, state, rootState }) {
    return new Promise((resolve, reject) => {
      const { type } = rootState.route.meta

      commit('SET_PENDING', { pending: true, type: 'editClient' })

      delete state.client.billing_handle
      delete state.client.admin_handle

      this.api.item
        .editItem(type, state.client)
        .then(({ data }) => {
          if (data && data.errors) {
            commit('EDIT_CLIENT_FAIL', data.errors)
            return
          }
          commit('EDIT_CLIENT_SUCCESS', data.client)
          resolve(data)
        })
        .catch(error => {
          commit('EDIT_CLIENT_FAIL', error)
          reject(error)
        })
        .finally(_ => {
          commit('SET_PENDING', { pending: false, type: 'editClient' })
        })
    })
  },
  searchClient({ commit }, searchString) {
    return new Promise((resolve, reject) => {
      commit('SET_PENDING', { pending: true, type: 'searchClient' })

      this.api.client
        .searchClient(searchString)
        .then(({ data }) => {
          commit('SEARCH_CLIENT_SUCCESS', data)
          resolve(data)
        })
        .catch(error => {
          commit('SEARCH_CLIENT_FAIL', error)
          reject(error)
        })
        .finally(_ => {
          commit('SET_PENDING', { pending: false, type: 'searchClient' })
        })
    })
  },
  clearClient({ commit }) {
    commit('CLEAR_CLIENT')
  },
  clearFoundClients({ commit }) {
    commit('CLEAR_FOUND_CLIENTS')
  },
}

const mutations = {
  SET_PENDING: (state, { pending, type = 'default' }) => {
    state.pending = { ...state.pending, [type]: pending }
  },
  CLEAR_CLIENT(state) {
    state.client = cloneDeep(client)
    state.invoices = []
    state.errors = {}
    state.options = null
  },
  CLEAR_FOUND_CLIENTS(state) {
    state.foundClients = []
    state.errors = {}
  },
  GET_CLIENT_SUCCESS(state, { client, invoices }) {
    state.errors = {}
    state.client = client
    state.invoices = invoices
  },
  GET_CLIENT_FAIL(state, errors) {
    state.errors = errors
  },
  GET_CLIENT_OPTIONS_SUCCESS(state, data) {
    state.options = data.options
  },
  GET_CLIENT_OPTIONS_FAIL(state, errors) {
    state.options = {}
  },
  ADD_CLIENT_SUCCESS(state) {
    state.errors = {}
  },
  ADD_CLIENT_FAIL(state, errors) {
    state.errors = errors
  },
  EDIT_CLIENT_SUCCESS(state, client) {
    state.errors = {}
  },
  EDIT_CLIENT_FAIL(state, errors) {
    state.errors = errors
  },
  SEARCH_CLIENT_SUCCESS(state, data) {
    if (data !== null) {
      state.foundClients = data.clients
    } else {
      state.foundClients = []
    }
  },
  SEARCH_CLIENT_FAIL(state, errors) {
    state.errors = errors
  },
  updateField,
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
